import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectRegion } from "../features/counter/RegionSlice";
import Sales from "../Data/Sales";
import { Bar } from "react-chartjs-2";
import { Box, Typography } from "@mui/material";


const FeedbackComparisonChart = () => {
  const region = useSelector(selectRegion);
  const [jsonData, setJsonData] = useState([]);
 

  useEffect(() => {
    const filteredData =
      region === "All Region"
        ? Sales.Data
        : Sales.Data.filter((item) => item.Region === region);
    setJsonData(filteredData);
  }, [region]);

  useEffect(() => {
    setJsonData(Sales.Data);
  }, []);

  const data = {
    labels: jsonData.map((item) => item.Salesman),
    datasets: [
      {
        label: "Positive",
        data: jsonData.map((item) => item.Positive),
        backgroundColor: "yellow",
      },
      {
        label: "Negative",
        data: jsonData.map((item) => item.Negative),
        backgroundColor: "purple",
      },
      {
        label: "Total",
        data: jsonData.map((item) => item.Total),
        backgroundColor: "lavender",
      },
    ],
  };

  const options = {
    scales: {
      x: {
        stacked: true,
        display: false,
      },
      y: {
        stacked: true,
        display: false,
      },
    },
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="body1" color="textPrimary">Feedback for {region}</Typography>
        <Box display="flex" gap={2}>
          <Typography variant="body2" display="flex" alignItems="center">
            <Box sx={{ width: 10, height: 10, backgroundColor: "purple", mr: 1 }} /> Negative
          </Typography>
          <Typography variant="body2" display="flex" alignItems="center">
            <Box sx={{ width: 10, height: 10, backgroundColor: "yellow", mr: 1 }} /> Positive
          </Typography>
        </Box>
      </Box>
      <Box>
        <Bar data={data} options={options} />
      </Box>
    </Box>
  );
};

export default FeedbackComparisonChart;
